import { z } from 'zod'
import { RecruitingEmploymentStatusEnum, RecruitingPayTypeEnum } from '../types'

export enum RecruitingStatusEnum {
  Active = 'active',
  Expired = 'expired',
  Cancelled = 'cancelled',
}

export const recruitingRequestSchema = z.object({
  id: z.string(),
  clientPublicKey: z.string().uuid(),
  benefitEffectiveDate: z.string(),
  contributionGroup: z.string(),
  employmentStatus: z.nativeEnum(RecruitingEmploymentStatusEnum),
  expiresAt: z.string(),
  cancelledAt: z.string().nullable().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  recipientEmail: z.string().optional(),
  isExempt: z.boolean(),
  payType: z.nativeEnum(RecruitingPayTypeEnum).optional(),
})

export type RecruitingRequest = z.infer<typeof recruitingRequestSchema>

export const RecruitingResponseSchema = z.object({
  data: z.array(recruitingRequestSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
})

export type RecruitingResponse = z.infer<typeof RecruitingResponseSchema>

export { RecruitingStatusEnum as RecruitingInvitationStatusEnum }
export type RecruitingInvitation = RecruitingRequest
export type RecruitingInvitationResponse = RecruitingResponse
